var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVaUpperTwo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54753 52.0209L26.6673 30.9011V38.4478L9.30753 55.7809C8.40086 55.5409 7.57419 55.0609 6.90753 54.4209C6.26753 53.7542 5.78753 52.9275 5.54753 52.0209Z",
    fill: "#E99921"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6673 10.3461L5.33398 31.6793V39.2259L26.6673 17.8928V10.3461Z",
    fill: "#E99921"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 7.99935C7.73398 7.99935 5.33398 10.3993 5.33398 13.3327V18.666L16.0007 7.99935H10.6673Z",
    fill: "#E99921"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1074 55.9994L26.6673 55.9993V51.4395L22.1074 55.9994Z",
    fill: "#E99921"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6673 2.66602H32.0007V61.3327H26.6673V2.66602Z",
    fill: "#E99921"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.334 18.666V13.3327H48.0007V7.99935H53.334V13.3327L58.6673 13.3327V18.666H53.334V45.3327H58.6673V50.666H53.334V55.9993H48.0007V50.666H37.334V45.3327H48.0007V18.666L37.334 18.666Z",
    fill: "#E99921"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVaUpperTwo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/va_upper_two.40accac63efee896c7fd50e98a8079b7.svg";